import api from "./api";
// TODO: Remove mock fallback once backend endpoints are stable
const generateMockContacts = () => {
  const companies = [
    "Acme Corporation",
    "Tech Solutions Inc",
    "Global Industries Ltd",
    "Innovation Systems",
    "Digital Dynamics",
    "Future Enterprises",
    "Smart Technologies",
    "NextGen Solutions",
    "Advanced Systems",
    "Premier Services",
    "Elite Corporation",
    "Dynamic Solutions",
    "Strategic Partners",
    "Excellence Group",
    "Prime Technologies",
    "Superior Systems",
  ];

  const cities = [
    "New York",
    "Los Angeles",
    "Chicago",
    "Houston",
    "Phoenix",
    "Philadelphia",
    "San Antonio",
    "San Diego",
    "Dallas",
    "San Jose",
    "Austin",
    "Jacksonville",
    "Fort Worth",
    "Columbus",
    "Charlotte",
    "San Francisco",
  ];
  const states = [
    "NY",
    "CA",
    "IL",
    "TX",
    "AZ",
    "PA",
    "FL",
    "OH",
    "GA",
    "NC",
    "WA",
    "OR",
    "NV",
    "UT",
    "CO",
    "MI",
  ];

  return Array.from({ length: 150 }, (_, i) => {
    const company = companies[i % companies.length];
    const city = cities[i % cities.length];
    const state = states[i % states.length];

    return {
      partyUuid: `550e8400-e29b-41d4-a716-${String(i).padStart(12, "0")}`,
      legalName: company,
      phone: `+1-555-${String(Math.floor(Math.random() * 900) + 100)}-${String(
        Math.floor(Math.random() * 9000) + 1000
      )}`,
      email: `contact${i + 1}@${company.toLowerCase().replace(/\s+/g, "")}.com`,
      address: {
        addressLine: `${Math.floor(Math.random() * 9999) + 1} ${
          [
            "Main",
            "Oak",
            "Pine",
            "Elm",
            "Cedar",
            "Maple",
            "First",
            "Second",
            "Third",
            "Fourth",
          ][i % 10]
        } St`,
        addressCity: city,
        addressState: state,
        addressPostalCode: `${Math.floor(Math.random() * 90000) + 10000}`,
      },
    };
  });
};

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const normalizeAddress = (address = null) => {
  if (!address) return null;

  return {
    addressLine: address.addressLine ?? address.address_line ?? null,
    addressCity: address.addressCity ?? address.address_city ?? null,
    addressState: address.addressState ?? address.address_state ?? null,
    addressPostalCode:
      address.addressPostalCode ?? address.address_postal_code ?? null,
    countryCode: address.countryCode ?? address.country_code ?? null,
  };
};

const normalizeContact = (contact = {}) => ({
  partyUuid: contact.partyUuid ?? contact.party_uuid ?? null,
  legalName: contact.legalName ?? contact.legal_name ?? null,
  phone: contact.phone ?? null,
  email: contact.email ?? null,
  address: normalizeAddress(contact.address),
});

const normalizeContactMeta = (meta = {}) => {
  if (!meta) return null;
  const normalized = {
    totalItems: meta.totalItems ?? meta.total_items ?? 0,
    totalPages: meta.totalPages ?? meta.total_pages ?? 0,
    currentPage: meta.currentPage ?? meta.current_page ?? 1,
    perPage: meta.perPage ?? meta.per_page ?? 0,
    hasNext: meta.hasNext ?? meta.has_next ?? false,
    hasPrevious: meta.hasPrevious ?? meta.has_previous ?? false,
    nextCursor: meta.nextCursor ?? meta.next_cursor ?? null,
  };

  return normalized;
};

const normalizePhone = (phone = {}) => ({
  partyPhoneUuid: phone.partyPhoneUuid ?? phone.party_phone_uuid ?? null,
  phoneType: phone.phoneType ?? phone.phone_type ?? null,
  phoneNumber: phone.phoneNumber ?? phone.phone_number ?? null,
  isPrimary: phone.isPrimary ?? phone.is_primary ?? false,
  createdAt: phone.createdAt ?? phone.created_at ?? null,
  updatedAt: phone.updatedAt ?? phone.updated_at ?? null,
  markedDeleted: phone.markedDeleted ?? phone.marked_deleted ?? false,
});

const normalizeEmail = (email = {}) => ({
  partyEmailUuid: email.partyEmailUuid ?? email.party_email_uuid ?? null,
  emailType: email.emailType ?? email.email_type ?? null,
  emailAddress: email.emailAddress ?? email.email_address ?? null,
  isPrimary: email.isPrimary ?? email.is_primary ?? false,
  createdAt: email.createdAt ?? email.created_at ?? null,
  updatedAt: email.updatedAt ?? email.updated_at ?? null,
  markedDeleted: email.markedDeleted ?? email.marked_deleted ?? false,
});

const normalizeContactAddress = (address = {}) => ({
  partyAddressUuid:
    address.partyAddressUuid ?? address.party_address_uuid ?? null,
  addressType: address.addressType ?? address.address_type ?? null,
  addressLine: address.addressLine ?? address.address_line ?? null,
  addressCity: address.addressCity ?? address.address_city ?? null,
  addressState: address.addressState ?? address.address_state ?? null,
  countryCode: address.countryCode ?? address.country_code ?? null,
  addressPostalCode:
    address.addressPostalCode ?? address.address_postal_code ?? null,
  createdAt: address.createdAt ?? address.created_at ?? null,
  updatedAt: address.updatedAt ?? address.updated_at ?? null,
});

const normalizeResponse = (data = {}, { bodyMapper } = {}) => {
  const statusCode = data.statusCode ?? data.status_code ?? null;
  const requestId = data.requestId ?? data.request_id ?? null;
  const msgCode = data.msgCode ?? data.msg_code ?? null;
  const headers = data.headers ?? null;

  const normalized = {
    statusCode,
    status_code: statusCode,
    requestId,
    request_id: requestId,
    msgCode,
    msg_code: msgCode,
    headers,
    meta: data.meta ? normalizeContactMeta(data.meta) : null,
  };

  if (bodyMapper) {
    if (data.body == null) {
      normalized.body = data.body ?? null;
    } else {
      normalized.body = bodyMapper(data.body);
    }
  } else {
    normalized.body = data.body ?? null;
  }

  return normalized;
};


const getMockContactPhones = async (params = {}) => {
  await delay(500);

  const mockPhones = [
    {
      partyPhoneUuid: `phone-${params.party_uuid}-main`,
      phoneType: "MAIN",
      phoneNumber: "+1-555-123-4567",
      isPrimary: true,
      createdAt: "2025-08-20T14:17:30Z",
      updatedAt: "2025-08-21T12:01:45Z",
      markedDeleted: false,
    },
    {
      partyPhoneUuid: `phone-${params.party_uuid}-mobile`,
      phoneType: "MOBILE",
      phoneNumber: "+1-555-987-6543",
      isPrimary: false,
      createdAt: "2025-08-20T14:17:30Z",
      updatedAt: "2025-08-21T12:01:45Z",
      markedDeleted: false,
    },
    {
      partyPhoneUuid: `phone-${params.party_uuid}-fax`,
      phoneType: "FAX",
      phoneNumber: "+1-555-111-2233",
      isPrimary: false,
      createdAt: "2025-08-20T14:17:30Z",
      updatedAt: "2025-08-21T12:01:45Z",
      markedDeleted: false,
    },
  ];

  return {
    status_code: 200,
    msg_code: [
      { code: "PHN_LIST_OK", description: "Phones listed successfully." },
    ],
    request_id: `req-${Date.now()}`,
    body: mockPhones,
    meta: {
      total_items: mockPhones.length,
      total_pages: 1,
      current_page: 1,
      per_page: 20,
      has_next: false,
      has_previous: false,
      next_cursor: null,
    },
  };
};

const getMockContactEmails = async (params = {}) => {
  await delay(500);

  const mockEmails = [
    {
      partyEmailUuid: `email-${params.party_uuid}-work`,
      emailType: "WORK",
      emailAddress: `contact${Math.floor(Math.random() * 1000)}@company.com`,
      isPrimary: true,
      createdAt: "2025-08-20T14:17:30Z",
      updatedAt: "2025-08-21T12:01:45Z",
      markedDeleted: false,
    },
    {
      partyEmailUuid: `email-${params.party_uuid}-personal`,
      emailType: "PERSONAL",
      emailAddress: `personal${Math.floor(Math.random() * 1000)}@gmail.com`,
      isPrimary: false,
      createdAt: "2025-08-20T14:17:30Z",
      updatedAt: "2025-08-21T12:01:45Z",
      markedDeleted: false,
    },
  ];

  return {
    status_code: 200,
    msg_code: [
      { code: "EML_LIST_OK", description: "Emails listed successfully." },
    ],
    request_id: `req-${Date.now()}`,
    body: mockEmails,
    meta: {
      total_items: mockEmails.length,
      total_pages: 1,
      current_page: 1,
      per_page: 20,
      has_next: false,
      has_previous: false,
      next_cursor: null,
    },
  };
};

const getMockContactAddresses = async (params = {}) => {
  await delay(500);

  const cities = ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix"];
  const states = ["NY", "CA", "IL", "TX", "AZ"];
  const addressTypes = ["HOME", "WORK", "BILLING"];

  const mockAddresses = Array.from({ length: 2 }, (_, i) => ({
    partyAddressUuid: `addr-${params.party_uuid}-${i}`,
    addressType: addressTypes[i % addressTypes.length],
    addressLine: `${Math.floor(Math.random() * 9999) + 1} ${
      ["Main", "Oak", "Pine"][i]
    } St`,
    addressCity: cities[i % cities.length],
    addressState: states[i % states.length],
    countryCode: "US",
    addressPostalCode: `${Math.floor(Math.random() * 90000) + 10000}`,
    createdAt: "2025-08-20T14:17:30Z",
    updatedAt: "2025-08-21T12:01:45Z",
  }));

  return {
    status_code: 200,
    msg_code: [
      { code: "ADDR_LIST_OK", description: "Addresses listed successfully." },
    ],
    request_id: `req-${Date.now()}`,
    body: mockAddresses,
    meta: {
      total_items: mockAddresses.length,
      total_pages: 1,
      current_page: 1,
      per_page: 20,
      has_next: false,
      has_previous: false,
      next_cursor: null,
    },
  };
};

export const getContactsList = async (params = {}) => {
  try {
    const body = {
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: params.order_by || ["createdAt"],
      order_direction: params.order_direction || ["DESC"],
      include_deleted: params.include_deleted || false,
      // search: params.search || null,
      search: {
        field: "legal_name",       
        keyword:params.search || null,
      },
      filters: params.filters || null,
    };

    const response = await api.post("/v1/workspace/contact/list", body);
    return normalizeResponse(response.data, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizeContact) : [],
    });
  } catch (error) {
    console.error("Error fetching contacts list:", error);
    throw error;
  }
};

export const getContactPreview = async (contactUuid) => {
  try {
    const response = await api.get(`/v1/workspace/contact/preview/${contactUuid}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching contact preview for ${contactUuid}:`, error);
    throw error;
  }
};

export const getContactPhones = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: params.order_by || ["createdAt"],
      order_direction: params.order_direction || ["DESC"],
      include_deleted: params.include_deleted || false,
      search: params.search || null,
      filters: params.filters || null,
    };

    const response = await api.post("/v1/workspace/contact/phone/list", body);
    return normalizeResponse(response.data, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizePhone) : [],
    });
  } catch (error) {
    console.warn("getContactPhones failed, using mock data fallback", error);
    const mockResponse = await getMockContactPhones(params);
    return normalizeResponse(mockResponse, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizePhone) : [],
    });
  }
};

export const getContactEmails = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: params.order_by || ["createdAt"],
      order_direction: params.order_direction || ["DESC"],
      include_deleted: params.include_deleted || false,
      search: params.search || null,
      filters: params.filters || null,
    };

    const response = await api.post("/v1/workspace/contact/email/list", body);
    return normalizeResponse(response.data, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizeEmail) : [],
    });
  } catch (error) {
    console.warn("getContactEmails failed, using mock data fallback", error);
    const mockResponse = await getMockContactEmails(params);
    return normalizeResponse(mockResponse, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizeEmail) : [],
    });
  }
};

export const getContactAddresses = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      order_by: params.order_by || ["createdAt"],
      order_direction: params.order_direction || ["DESC"],
      search: params.search || null,
      filters: params.filters || null,
    };

    const response = await api.post("/v1/workspace/contact/address/list", body);
    return normalizeResponse(response.data, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizeContactAddress) : [],
    });
  } catch (error) {
    console.warn("getContactAddresses failed, using mock data fallback", error);
    const mockResponse = await getMockContactAddresses(params);
    return normalizeResponse(mockResponse, {
      bodyMapper: (payload) =>
        Array.isArray(payload) ? payload.map(normalizeContactAddress) : [],
    });
  }
};

// ==================== PHONE CRUD OPERATIONS ====================
// Mock implementations

const getMockCreateContactPhone = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, phone_type, phone_number, is_primary } = params;
  
  // Validate required fields
  if (!party_uuid || !phone_type || !phone_number || is_primary === undefined) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_REQUEST",
        description: "Missing required fields"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate UUID format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_UUID",
        description: "Invalid party UUID format"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate E.164 phone format: ^\+[1-9]\d{7,14}$
  const e164Regex = /^\+[1-9]\d{7,14}$/;
  
  if (!e164Regex.test(phone_number)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_FORMAT",
        description: "Phone number must follow E.164 format (+[country][number], 8-15 digits total)"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "PHN_PARTY_NOT_FOUND",
        description: "Contact not found"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate check for active duplicate
  const phoneResponse = await getContactPhones({ party_uuid });
  const existingPhones = phoneResponse.body || [];
  const activeDuplicate = existingPhones.find(
    p => p.phoneNumber === phone_number && !p.markedDeleted
  );
  
  if (activeDuplicate) {
    return {
      status_code: 409,
      msg_code: [{
        code: "PHN_CONFLICT",
        description: "A phone number with the same value already exists for this contact."
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Check for soft-deleted match (reactivation scenario)
  const deletedPhone = existingPhones.find(
    p => p.phoneNumber === phone_number && p.markedDeleted
  );
  
  if (deletedPhone) {
    console.log(`[MOCK] Reactivating previously deleted phone ${deletedPhone.partyPhoneUuid}`);
    console.log(`[MOCK] Updated is_primary=${is_primary}, phone_type=${phone_type.toUpperCase()}`);
  } else {
    console.log(`[MOCK] Creating new phone with number ${phone_number}`);
    console.log(`[MOCK] phone_type=${phone_type.toUpperCase()}, is_primary=${is_primary}`);
  }
  
  // Simulate primary demotion
  if (is_primary) {
    const otherPrimaries = existingPhones.filter(
      p => p.isPrimary && p.phoneNumber !== phone_number && !p.markedDeleted
    );
    
    if (otherPrimaries.length > 0) {
      console.log(`[MOCK] Demoting ${otherPrimaries.length} other primary phone(s)`);
    }
  }
  
  return {
    status_code: 201,
    msg_code: [{
      code: "PHN_CREATED_OK",
      description: "Phone record created or reactivated successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

const getMockUpdateContactPhone = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, party_phone_uuid, phone_number, is_primary } = params;
  
  // Validate that at least one field to update is provided
  if (phone_number === undefined && is_primary === undefined) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_NO_FIELDS",
        description: "Nothing to update"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate UUIDs format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!party_uuid || !uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_PARTY_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  if (!party_phone_uuid || !uuidRegex.test(party_phone_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_PHONE_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate phone_number format if provided (E.164)
  const e164Regex = /^\+[1-9]\d{7,14}$/;
  if (phone_number !== undefined && !e164Regex.test(phone_number)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_FORMAT",
        description: "Reject non-E.164"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate is_primary format if provided
  if (is_primary !== undefined && typeof is_primary !== 'boolean') {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_PRIMARY_INVALID",
        description: "Reject non-boolean"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "PHN_PARTY_NOT_FOUND",
        description: "Party not found/deleted/demo"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate phone lookup
  const phoneResponse = await getContactPhones({ party_uuid });
  const phones = phoneResponse.body || [];
  const targetPhone = phones.find(p => p.partyPhoneUuid === party_phone_uuid && !p.markedDeleted);
  
  if (!targetPhone) {
    return {
      status_code: 404,
      msg_code: [{
        code: "PHN_TARGET_NOT_FOUND",
        description: "Target record not found/deleted"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Handle phone_number update logic
  if (phone_number && phone_number !== targetPhone.phoneNumber) {
    // Check for active duplicate
    const activeDuplicate = phones.find(
      p => p.phoneNumber === phone_number && 
           !p.markedDeleted && 
           p.partyPhoneUuid !== party_phone_uuid
    );
    
    if (activeDuplicate) {
      return {
        status_code: 409,
        msg_code: [{
          code: "PHN_CONFLICT",
          description: "Active duplicate phone"
        }],
        request_id: `req-${Date.now()}`,
        body: null,
        meta: null
      };
    }
    
    // Check for soft-deleted match
    const deletedDuplicate = phones.find(
      p => p.phoneNumber === phone_number && p.markedDeleted
    );
    
    if (deletedDuplicate) {
      console.log(`[MOCK] Reactivating deleted phone ${deletedDuplicate.partyPhoneUuid}`);
      console.log(`[MOCK] Soft-deleting current phone ${party_phone_uuid}`);
      
      return {
        status_code: 200,
        msg_code: [{
          code: "PHN_UPDATE_OK",
          description: "Reactivation success"
        }],
        request_id: `req-${Date.now()}`,
        body: null,
        meta: null
      };
    }
    
    console.log(`[MOCK] Updating phone number from ${targetPhone.phoneNumber} to ${phone_number}`);
  }
  
  // Handle is_primary update logic
  if (is_primary !== undefined && is_primary !== targetPhone.isPrimary) {
    if (is_primary) {
      const otherPrimaries = phones.filter(
        p => p.isPrimary && 
             p.partyPhoneUuid !== party_phone_uuid && 
             !p.markedDeleted
      );
      
      if (otherPrimaries.length > 0) {
        console.log(`[MOCK] Demoting ${otherPrimaries.length} other primary phone(s)`);
      }
    }
    
    console.log(`[MOCK] Setting is_primary=${is_primary} for phone ${party_phone_uuid}`);
  }
  
  return {
    status_code: 200,
    msg_code: [{
      code: "PHN_UPDATE_OK",
      description: "Phone record updated successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

const getMockDeleteContactPhone = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, party_phone_uuid } = params;
  
  // Validate UUIDs format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!party_uuid || !uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_PARTY_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  if (!party_phone_uuid || !uuidRegex.test(party_phone_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "PHN_INVALID_PHONE_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "PHN_PARTY_NOT_FOUND",
        description: "Contact not found"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate phone lookup
  const phoneResponse = await getContactPhones({ party_uuid });
  const phones = phoneResponse.body || [];
  const targetPhone = phones.find(p => p.partyPhoneUuid === party_phone_uuid);
  
  if (!targetPhone) {
    return {
      status_code: 404,
      msg_code: [{
        code: "PHN_TARGET_NOT_FOUND",
        description: "Target phone not found or already deleted"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Check if already deleted (idempotent)
  if (targetPhone.markedDeleted) {
    return {
      status_code: 200,
      msg_code: [{
        code: "PHN_DELETE_OK",
        description: "Phone record deleted successfully."
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // SUCCESS - Simulate soft-delete with primary reassignment
  console.log(`[MOCK] Soft-deleting phone ${party_phone_uuid}`);
  
  if (targetPhone.isPrimary) {
    const remainingPhones = phones.filter(
      p => p.partyPhoneUuid !== party_phone_uuid && !p.markedDeleted
    );
    
    if (remainingPhones.length > 0) {
      const randomIndex = Math.floor(Math.random() * remainingPhones.length);
      console.log(`[MOCK] Promoting phone ${remainingPhones[randomIndex].partyPhoneUuid} to primary`);
    } else {
      console.log(`[MOCK] No remaining active phones, party will have no primary`);
    }
  }
  
  return {
    status_code: 200,
    msg_code: [{
      code: "PHN_DELETE_OK",
      description: "Phone record deleted successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

// ==================== EMAIL CRUD OPERATIONS ====================
// Mock implementations

const getMockCreateContactEmail = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, email_type, email_address, is_primary } = params;
  
  // Validate required fields
  if (!party_uuid || !email_type || !email_address || is_primary === undefined) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_REQUEST",
        description: "Missing required fields"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate UUID format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_PARTY_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate email format (RFC-5322 - basic check)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  if (!emailRegex.test(email_address)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_FORMAT",
        description: "RFC-5322 validation failure"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate email_type
  if (!email_type || email_type.trim() === '') {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_TYPE_INVALID",
        description: "Reject null/empty"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate is_primary
  if (typeof is_primary !== 'boolean') {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_PRIMARY_INVALID",
        description: "Must be boolean"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "EML_PARTY_NOT_FOUND",
        description: "Party not found/inactive"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Normalize email to lowercase for comparison
  const emailLowercase = email_address.toLowerCase();
  
  // Simulate check for active duplicate (case-insensitive)
  const emailResponse = await getContactEmails({ party_uuid });
  const existingEmails = emailResponse.body || [];
  const activeDuplicate = existingEmails.find(
    e => e.emailAddress.toLowerCase() === emailLowercase && !e.markedDeleted
  );
  
  if (activeDuplicate) {
    return {
      status_code: 409,
      msg_code: [{
        code: "EML_CONFLICT",
        description: "An email with the same value already exists for this contact."
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Check for soft-deleted match (reactivation scenario)
  const deletedEmail = existingEmails.find(
    e => e.emailAddress.toLowerCase() === emailLowercase && e.markedDeleted
  );
  
  if (deletedEmail) {
    console.log(`[MOCK] Reactivating previously deleted email ${deletedEmail.partyEmailUuid}`);
    console.log(`[MOCK] Updated is_primary=${is_primary}, email_type=${email_type.toUpperCase()}`);
  } else {
    console.log(`[MOCK] Creating new email ${emailLowercase}`);
    console.log(`[MOCK] email_type=${email_type.toUpperCase()}, is_primary=${is_primary}`);
  }
  
  // Simulate primary demotion
  if (is_primary) {
    const otherPrimaries = existingEmails.filter(
      e => e.isPrimary && e.emailAddress.toLowerCase() !== emailLowercase && !e.markedDeleted
    );
    
    if (otherPrimaries.length > 0) {
      console.log(`[MOCK] Demoting ${otherPrimaries.length} other primary email(s)`);
    }
  }
  
  return {
    status_code: 201,
    msg_code: [{
      code: "EML_CREATED_OK",
      description: "Email record created or reactivated successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

const getMockUpdateContactEmail = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, party_email_uuid, email_address, is_primary } = params;
  
  // Validate that at least one field to update is provided
  if (email_address === undefined && is_primary === undefined) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_NO_FIELDS",
        description: "Nothing to update"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate UUIDs format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!party_uuid || !uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_PARTY_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  if (!party_email_uuid || !uuidRegex.test(party_email_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_EMAIL_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate email_address format if provided (RFC-5322 - basic check)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (email_address !== undefined && !emailRegex.test(email_address)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_FORMAT",
        description: "RFC-5322 validation failure"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Validate is_primary format if provided
  if (is_primary !== undefined && typeof is_primary !== 'boolean') {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_PRIMARY_INVALID",
        description: "Reject non-boolean"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "EML_PARTY_NOT_FOUND",
        description: "Contact not found/inactive"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate email lookup
  const emailResponse = await getContactEmails({ party_uuid });
  const emails = emailResponse.body || [];
  const targetEmail = emails.find(e => e.partyEmailUuid === party_email_uuid && !e.markedDeleted);
  
  if (!targetEmail) {
    return {
      status_code: 404,
      msg_code: [{
        code: "EML_TARGET_NOT_FOUND",
        description: "Not found or already deleted"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Normalize email to lowercase
  const emailLowercase = email_address ? email_address.toLowerCase() : null;
  
  // Handle email_address update logic
  if (emailLowercase && emailLowercase !== targetEmail.emailAddress.toLowerCase()) {
    // Check for active duplicate (case-insensitive)
    const activeDuplicate = emails.find(
      e => e.emailAddress.toLowerCase() === emailLowercase && 
           !e.markedDeleted && 
           e.partyEmailUuid !== party_email_uuid
    );
    
    if (activeDuplicate) {
      return {
        status_code: 409,
        msg_code: [{
          code: "EML_CONFLICT",
          description: "Active duplicate email"
        }],
        request_id: `req-${Date.now()}`,
        body: null,
        meta: null
      };
    }
    
    // Check for soft-deleted match
    const deletedDuplicate = emails.find(
      e => e.emailAddress.toLowerCase() === emailLowercase && e.markedDeleted
    );
    
    if (deletedDuplicate) {
      console.log(`[MOCK] Reactivating deleted email ${deletedDuplicate.partyEmailUuid}`);
      console.log(`[MOCK] Soft-deleting current email ${party_email_uuid}`);
      
      return {
        status_code: 200,
        msg_code: [{
          code: "EML_UPDATE_OK",
          description: "Email record updated successfully."
        }],
        request_id: `req-${Date.now()}`,
        body: null,
        meta: null
      };
    }
    
    console.log(`[MOCK] Updating email from ${targetEmail.emailAddress} to ${emailLowercase}`);
  }
  
  // Handle is_primary update logic
  if (is_primary !== undefined && is_primary !== targetEmail.isPrimary) {
    if (is_primary) {
      const otherPrimaries = emails.filter(
        e => e.isPrimary && 
             e.partyEmailUuid !== party_email_uuid && 
             !e.markedDeleted
      );
      
      if (otherPrimaries.length > 0) {
        console.log(`[MOCK] Demoting ${otherPrimaries.length} other primary email(s)`);
      }
    }
    
    console.log(`[MOCK] Setting is_primary=${is_primary} for email ${party_email_uuid}`);
  }
  
  return {
    status_code: 200,
    msg_code: [{
      code: "EML_UPDATE_OK",
      description: "Email record updated successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

const getMockDeleteContactEmail = async (params = {}) => {
  // Simulate API delay
  await delay(500);
  
  const { party_uuid, party_email_uuid } = params;
  
  // Validate UUIDs format
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  
  if (!party_uuid || !uuidRegex.test(party_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_PARTY_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  if (!party_email_uuid || !uuidRegex.test(party_email_uuid)) {
    return {
      status_code: 400,
      msg_code: [{
        code: "EML_INVALID_EMAIL_UUID",
        description: "Reject malformed UUID"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate party lookup
  const allContacts = generateMockContacts();
  const contact = allContacts.find(c => c.partyUuid === party_uuid);
  
  if (!contact) {
    return {
      status_code: 404,
      msg_code: [{
        code: "EML_PARTY_NOT_FOUND",
        description: "Contact not found/inactive"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Simulate email lookup
  const emailResponse = await getContactEmails({ party_uuid });
  const emails = emailResponse.body || [];
  const targetEmail = emails.find(e => e.partyEmailUuid === party_email_uuid);
  
  if (!targetEmail) {
    return {
      status_code: 404,
      msg_code: [{
        code: "EML_TARGET_NOT_FOUND",
        description: "Record not found"
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Check if already deleted (idempotent)
  if (targetEmail.markedDeleted) {
    return {
      status_code: 200,
      msg_code: [{
        code: "EML_DELETE_OK",
        description: "Email record marked as deleted successfully."
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // Primary guard: cannot delete primary email
  if (targetEmail.isPrimary) {
    return {
      status_code: 409,
      msg_code: [{
        code: "EML_CANNOT_DELETE_PRIMARY",
        description: "The current primary email cannot be deleted."
      }],
      request_id: `req-${Date.now()}`,
      body: null,
      meta: null
    };
  }
  
  // SUCCESS - Simulate soft-delete (no primary reassignment for emails)
  console.log(`[MOCK] Soft-deleting email ${party_email_uuid}`);
  
  return {
    status_code: 200,
    msg_code: [{
      code: "EML_DELETE_OK",
      description: "Email record marked as deleted successfully."
    }],
    request_id: `req-${Date.now()}`,
    body: null,
    meta: null
  };
};

// ==================== EXPORTED FUNCTIONS WITH FALLBACK ====================

// Create contact phone (with fallback)
export const createContactPhone = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      phone_type: params.phone_type,
      phone_number: params.phone_number,
      is_primary: params.is_primary
    };
    const response = await api.post("/v1/workspace/contact/phone/create", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("createContactPhone failed, using mock fallback", error);
    const mockResponse = await getMockCreateContactPhone(params);
    return normalizeResponse(mockResponse);
  }
};

// Update contact phone (with fallback)
export const updateContactPhone = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      party_phone_uuid: params.party_phone_uuid,
      phone_number: params.phone_number,
      is_primary: params.is_primary
    };
    const response = await api.post("/v1/workspace/contact/phone/update", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("updateContactPhone failed, using mock fallback", error);
    const mockResponse = await getMockUpdateContactPhone(params);
    return normalizeResponse(mockResponse);
  }
};

// Delete contact phone (with fallback)
export const deleteContactPhone = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      party_phone_uuid: params.party_phone_uuid
    };
    const response = await api.post("/v1/workspace/contact/phone/delete", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("deleteContactPhone failed, using mock fallback", error);
    const mockResponse = await getMockDeleteContactPhone(params);
    return normalizeResponse(mockResponse);
  }
};

// Create contact email (with fallback)
export const createContactEmail = async (params = {}) => {
  try {
    const body = {
      partyUuid: params.party_uuid || params.partyUuid,
      emailType: params.email_type || params.emailType,
      emailAddress: params.email_address || params.emailAddress,
      isPrimary: params.is_primary !== undefined ? params.is_primary : params.isPrimary
    };
    const response = await api.post("/v1/workspace/contact/email/create", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("createContactEmail failed, using mock fallback", error);
    const mockResponse = await getMockCreateContactEmail(params);
    return normalizeResponse(mockResponse);
  }
};

// Update contact email (with fallback)
export const updateContactEmail = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      party_email_uuid: params.party_email_uuid,
      email_address: params.email_address,
      is_primary: params.is_primary
    };
    const response = await api.post("/v1/workspace/contact/email/update", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("updateContactEmail failed, using mock fallback", error);
    const mockResponse = await getMockUpdateContactEmail(params);
    return normalizeResponse(mockResponse);
  }
};

// Delete contact email (with fallback)
export const deleteContactEmail = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      party_email_uuid: params.party_email_uuid
    };
    const response = await api.post("/v1/workspace/contact/email/delete", body);
    return normalizeResponse(response.data);
  } catch (error) {
    console.warn("deleteContactEmail failed, using mock fallback", error);
    const mockResponse = await getMockDeleteContactEmail(params);
    return normalizeResponse(mockResponse);
  }
};

// ==================== PARTY TEAM ====================

export const getPartyTeam = async (partyUuid) => {
  try {
    const body = {
      party_uuid: partyUuid
    };
    
    const response = await api.post("/v1/workspace/contact/team/list", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching party team:", error);
    throw error;
  }
};
